import {
  INITIALIZE_TABLE, CANCEL_TABLE, RESERVE_SEAT, PLAYERS_NUMBER,
} from '@ezugi/constants';

export const MINILOBBY_RESERVE_SEAT = RESERVE_SEAT;
export const MINILOBBY_PLAYERS_NUMBER_UPDATE = PLAYERS_NUMBER;
export const MINILOBBY_SUBMESSAGE_TYPES = {
  INITIALIZE_TABLE,
  CANCEL_TABLE,
};

export const BJ_SEATS_NUMBER = 7;
export const MIN_NUMBER_LIMITS_TO_DISPLAY = 2;
export const MY_LOBBY_GROUP_ID = 0;
export const MINILOBBY_NAVBAR_SIZES = {
  ITEM_HEIGHT: 28,
  ITEM_MARGINS: 8,
  UNDERLINE_MARGIN_TOP: 2,
  UNDERLINE_HEIGHT: 2,
};

export const BJSP_GAME_ID = 46;
export const UBJ_GAME_ID = 12;
export const BJ_GAME_IDS = [ 1, 10, 12, 46, 51 ];

export const BJ_NEW_TABLE_DEFAULT_SEATS = [
  {
    Taken: false,
    SeatId: 's1',
  },
  {
    Taken: false,
    SeatId: 's2',
  },
  {
    Taken: false,
    SeatId: 's3',
  },
  {
    Taken: false,
    SeatId: 's4',
  },
  {
    Taken: false,
    SeatId: 's5',
  },
  {
    Taken: false,
    SeatId: 's6',
  },
  {
    Taken: false,
    SeatId: 's7',
  },
  {
    Taken: true,
    SeatId: 'd',
  },
];

export const SPLIT_SEAT_SUFFIX = '-2';

/** Custom sortings for tables belonging to specific group table */
export const GROUP_TABLES_CUSTOM_SORTING = {
  /** Custom sorting to be applied to blackjack and american blackjack tables when BO's sort_bj_category is configured */
  BJ_BY_SEATS: 'sortBjCategory',
};

/**
 * Properties of a custom sorting rule
 *
 * note: the assumption is all BO configs for custom sorts have the same json structure, like:
 * ```
 * {
 *    enableSort: true,
 *    groupName: "a group name",
 * }
 * ```
 */
export const CUSTOM_SORT_CONFIG = {
  ENABLE_SORT_PROP: 'enableSort',
  GROUP_NAME_PROP: 'groupName',
};

/** All available options for BO config `tables_sorting_type` */
export const TABLES_SORTING_TYPE_CONFIG = {
  DEFAULT: 'default',
  LANGUAGE: 'language',
  LIMITS: 'limits',
};
